import React, {Component} from "react";
import {FormattedMessage} from "react-intl";

class RoadAssist extends Component {

  render() {
    const {selected} = this.props;
    const selectedCss = selected === true ? undefined : "choice-card--unselected";

    return (
      <div className="col-sm-6 col-lg-3">
        <div className={["choice-card", selectedCss].join(' ')} onClick={this.props.onSelect}>
          <header className="choice-card__header">
            <h4 className="choice-card__title">
              {<FormattedMessage id={'appointment.detail.mobility.roadAssist.title'}/>}</h4>
          </header>
          <div className="choice-card__body">

          </div>
        </div>
      </div>
    )
  }
}

export default RoadAssist;
